import React from 'react';
import { Input, Box, FormControl, FormLabel, FormHelperText, InputGroup, InputRightElement } from '@chakra-ui/react';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';

const TextFormField = (props) => {
	const { name, type, label, placeholder, required, rightElement, min, disabled = false, font = '', size = 'lg', mb = '4' } = props;
	const { t } = useTranslation();

	return (
		<Field name={name}>
			{({ field, meta }) => (
				<Box mb={mb}>
					<FormControl id={name}>
						<FormLabel>
							{t(label)}
							{required && <span style={{ color: 'red' }}>*</span>}
						</FormLabel>
						<InputGroup size="md">
							<Input
								{...field}
								value={field?.value ? field?.value : ''}
								id={name}
								type={type ? type : 'text'}
								placeholder={placeholder ? placeholder : ''}
								size={size}
								errorBorderColor="red.300"
								isInvalid={meta.touched && meta.error}
								step="any"
								min={min ? min : null}
								onWheelCapture={(e) => e.target.blur()}
								disabled={disabled}
								fontFamily={font}
							/>
							{rightElement && <InputRightElement width="6rem">{rightElement}</InputRightElement>}
						</InputGroup>
						{meta.touched && meta.error && (
							<FormHelperText id={`error-message-${name}`} color="red.400" fontSize="12px">
								{t(name)} {t('is')} {t(meta.error)}
							</FormHelperText>
						)}
					</FormControl>
				</Box>
			)}
		</Field>
	);
};

export default TextFormField;
